import RequestService from './request';

export interface DeviceAuthResponse {
    device_code: string;
    verification_uri_complete: string;
    expires_in: number;
    interval: number;
}

export interface PollDeviceAuthResponse {
    status: 'pending' | 'completed';
}

export interface CompletedDeviceAuthResponse extends PollDeviceAuthResponse {
    status: 'completed';
    profileUuid: string;
    profileUsername: string;
}

class HytaleConfigurationService {
    deviceAuth(): Promise<DeviceAuthResponse> {
        return RequestService.get('/settings/hytale/device-auth');
    }

    pollDeviceAuth(pollDeviceAuthRequest: { device_code: string }): Promise<void> {
        return RequestService.post('/settings/hytale/poll-device-auth', pollDeviceAuthRequest);
    }

    unlinkAccount(): Promise<void> {
        return RequestService.post('/settings/hytale/unlink-account');
    }
}

export default new HytaleConfigurationService();
